import styled from 'styled-components';
import { Colors } from '../../colors';
export const Currency = styled.span `
  font-size: 0.75em;
  color: ${Colors.GS600};
`;
